import React, {Component} from 'react'
import {connectHits, Pagination} from 'react-instantsearch-dom'
import ProductCard from './product-card'
import Stats from '../collection/filters/stats'
import {HITS_PER_RESULTS} from '../config'
import {isCa} from "@/scripts/util/countryCheck"

class Hits extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hitsViewed: HITS_PER_RESULTS,
        }
    }

    render() {
        const {
            hits,
            collection
        } = this.props

        const {hitsViewed} = this.state

        const showGSTspan = !isCa()

        const productList = hits.map(product => {
            return (
                <ProductCard
                    showGst={showGSTspan}
                    product={product}
                    key={product.id}
                    collection={collection}
                />
            )
        })

        return (
            <React.Fragment>
                <div className="row margin-bottom-3x small-margin-0x">
                    {productList}
                </div>
                <div className="column column-12 small-padding-top-2x text-center stats">
                    <Stats hitsLeft={false}/>
                </div>
                <div className="row margin-top-2x">
                    <div className="column text-center">
                        <Pagination
                            showFirst={false}
                            showLast={false}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const ProductHits = connectHits(Hits)

export default ProductHits
